var _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCwLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 3250 3250",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.0906 0 0 1.0708 -160.7 -135.14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1535 1361c-91.86 35.38-152.51 926.95-370 1129 7.98 28.78 99.34 118.66 261 73 165.79-58.26 247.56-767.82 367-1052-118.29-211.54-183.05-188.98-258-150zm1277 56c-207.52-127.77-352.18 830.97-653 775 95.37 133.16 66.81 253.8 363 178 145.41-116.77 391.91-907.54 581-697-26.2-94.82-194.02-207.01-291-256z",
    fill: "#014c57"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.0906 0 0 1.0708 -160.7 -135.14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1877.3 1852.3c-207.04-597.97-267.39-548.23-376.32-439.3 68.96-204.87 225.61-183.71 384-127 212.04 92.71 410.31 1306 698 1009-86.37 171.46-235.86 175.43-418 155-27.3-3.06-118.39-108.8-287.68-597.7zm-1226.3-718.3c64.387 188.53 612.3 1695.4 866 1323-109.68 195.3-171.12 146-371 146-207.87-11.99-439.66-941.57-495-1469z",
    fill: "#207b88"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.0906 0 0 1.0708 -160.7 -135.14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m507 1578c1.732 879.85 653.98 1174.6 984 1220 320.92 47.96 768.05-61.94 1053-394 332.65-439.13 357.32-982.11 219-995 37.05-29.74 345.38 168.95 347 282 1.86 129.4-92.57 1408.2-1446.4 1456.9-452.34 34.2-1514.7-375.5-1503.6-1552.9 115.98-1349.7 1343.1-1470.9 1499-1455 241.28-1.407 911.78 82.6 1303 763 12.44 76.613-102.55 234.98-222 299-253.1-516.74-627.12-699.62-1085-716-594.8 35.721-1088.5 423.61-1148 1092z",
    fill: "#207b88"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCwLogo);
export default __webpack_public_path__ + "static/media/CW-Logo.7d6fc1b2c5fc69f65eee31d1e4762798.svg";
export { ForwardRef as ReactComponent };